import React from 'react';
import { Outlet } from 'react-router-dom';

const HomeParent = () => {
  return (
    <React.Fragment>
      <Outlet />
    </React.Fragment>
  );
};

export default HomeParent;
